import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
})
export class DeleteButtonComponent {
    @Input() disabled: boolean = false;

    @Output() deleteConfirmed: EventEmitter<void> = new EventEmitter<void>();

    buttonColor: 'dark' | 'danger' = 'dark';

    public toggleColor() {
        if (this.disabled) {
            return;
        }

        if (this.buttonColor === 'dark') {
            this.buttonColor = 'danger';
        } else if (this.buttonColor === 'danger') {
            this.buttonColor = 'dark';
            this.deleteConfirmed.emit();
        }
    }
}
